import { TiHome, TiLocation, TiPlaneOutline } from 'react-icons/ti';

import styled from 'styled-components';

type ResultProps = {
  $isAirportRelated?: boolean;
};

const Result: any = styled.li`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.airportsSearch.hover};
  }
`;

Result.info = styled.div`
  display: flex;
  flex-direction: column;
`;

Result.info.airport = styled.div<ResultProps>`
  display: flex;
  flex-direction: column;
  margin-left: ${($isAirportRelated) => ($isAirportRelated ? '20px' : '0px')};
`;

Result.Title = styled.span`
  font-size: 16px;
  font-weight: 600;
  display: flex;
`;

Result.SubTitle = styled.p`
  font-size: 12px;
  font-weight: normal;
  margin-top: 5px;
`;

Result.Code = styled.div`
  font-size: 16px;
  margin-left: auto;
  color: ${({ theme }) => theme.airportsSearch.airportCode};
`;

Result.IconContainer = styled.div`
  width: 14px;
  height: 14px;
  margin-right: 5px;
`;

Result.icon = styled(TiLocation)`
  font-size: 14px;
  margin-right: 5px;
`;

Result.iconairport = styled(TiPlaneOutline)`
  font-size: 12px;
  margin-right: 5px;
`;

Result.iconhotel = styled(TiHome)`
  font-size: 12px;
  margin-right: 5px;
`;

export default Result;
